import { centerable as r } from "../decorators/centerable.js";
import { stylable as i } from "../decorators/stylable.js";
import { generateHeadingId as t } from "../../helpers/id-generator.js";
import { defineAttrs as n } from "../../utils/typed-attrs.js";
const s = n({
  type: { default: "heading" },
  idAttribute: { default: "" }
}), A = i(
  r({
    content: "inline*",
    attrs: s,
    defining: !0,
    group: "block",
    parseDOM: [
      {
        tag: "h1",
        getAttrs() {
          return {
            idAttribute: t()
          };
        }
      },
      {
        tag: 'p[role=heading][aria-level="1"]',
        priority: 60,
        getAttrs() {
          return {
            idAttribute: t()
          };
        }
      }
    ],
    toDOM(e) {
      return ["h1", { id: e.attrs.idAttribute }, 0];
    }
  })
), u = n({
  type: { default: "subheading" },
  idAttribute: { default: "" }
}), c = i(
  r({
    content: "inline*",
    attrs: u,
    defining: !0,
    group: "block",
    parseDOM: [
      {
        tag: "h2",
        getAttrs() {
          return {
            idAttribute: t()
          };
        }
      },
      {
        tag: 'p[role=heading][aria-level="2"]',
        priority: 60,
        getAttrs() {
          return {
            idAttribute: t()
          };
        }
      },
      {
        tag: "h3",
        getAttrs() {
          return {
            idAttribute: t()
          };
        }
      },
      {
        tag: 'p[role=heading][aria-level="3"]',
        priority: 60,
        getAttrs() {
          return {
            idAttribute: t()
          };
        }
      },
      {
        tag: "h4",
        getAttrs() {
          return {
            idAttribute: t()
          };
        }
      },
      {
        tag: 'p[role=heading][aria-level="4"]',
        priority: 60,
        getAttrs() {
          return {
            idAttribute: t()
          };
        }
      }
    ],
    toDOM(e) {
      return ["h2", { id: e.attrs.idAttribute }, 0];
    }
  })
), d = n({
  type: { default: "subheading3" },
  idAttribute: { default: "" }
}), h = i(
  r({
    content: "inline*",
    attrs: d,
    defining: !0,
    group: "block",
    parseDOM: [],
    toDOM(e) {
      return ["h3", { id: e.attrs.idAttribute }, 0];
    }
  })
), o = n({
  type: { default: "subheading4" },
  idAttribute: { default: "" }
}), f = i(
  r({
    content: "inline*",
    attrs: o,
    defining: !0,
    group: "block",
    parseDOM: [],
    toDOM(e) {
      return ["h4", { id: e.attrs.idAttribute }, 0];
    }
  })
);
export {
  A as headingSpec,
  h as subheading3Spec,
  f as subheading4Spec,
  c as subheadingSpec
};
